import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

export const getStructure = () => api.get("/scan/structure").then((r) => r.data);
export const submitScan = (payload) => api.post("/scan/submit", payload).then((r) => r.data);
export const getResult = (id) => api.get(`/results/${id}`).then((r) => r.data);
export const getPaidResult = (id) => api.get(`/results/${id}/paid`).then((r) => r.data);
export const emailResults = (id, email) => api.post(`/results/${id}/email`, { email }).then((r) => r.data);
export const setReminder = (id, email) => api.post(`/results/${id}/reminder`, { email }).then((r) => r.data);
export const registerPaidInterest = (email, resultId) => api.post(`/paid-interest`, { email, result_id: resultId }).then((r) => r.data);
export const subscribeNewsletter = (email) => api.post(`/newsletter`, { email }).then((r) => r.data);

const authHeader = (token) => ({ headers: { Authorization: `Bearer ${token}` } });
export const adminLogin = (password) => api.post(`/admin/login`, { password }).then((r) => r.data);
export const adminStats = (token) => api.get(`/admin/stats`, authHeader(token)).then((r) => r.data);
export const adminAssessments = (token) => api.get(`/admin/assessments`, authHeader(token)).then((r) => r.data);

export default api;
